import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { BasicInformatioTableDef } from '../../../../../containers/SingleSheetV2/table/model'
import {
  isProjectCodeEditable,
  isProjectStatusEditable,
  isWbsItemCodeFormatEditable,
} from '../../../../../../domain/entity/ProjectEntity'
import {
  PROJECT_BASIC_INFORMATION_HEADER_ID,
  ProjectCellOptions,
  useProjectCellDefs,
} from './cellDefs'

// プロジェクト登録画面（projectEdit）の基本情報テーブル。
// 作成/更新で編集可否が変わる（code・wbsItemCodeFormat は作成時のみ可、status は更新時のみ可）。
export const useProjectEditBasicInformationTableDef = (
  isCreating: boolean,
  options: ProjectCellOptions
): BasicInformatioTableDef => {
  const intl = useIntl()
  const cells = useProjectCellDefs(options, {
    code: isProjectCodeEditable(isCreating),
    status: isProjectStatusEditable(isCreating),
    wbsItemCodeFormat: isWbsItemCodeFormatEditable(isCreating),
  })
  return useMemo<BasicInformatioTableDef>(
    () => ({
      tables: [
        {
          header: {
            externalId: PROJECT_BASIC_INFORMATION_HEADER_ID,
            label: intl.formatMessage({ id: 'projectV2.basicInformation' }),
          },
          rows: [
            [cells.code],
            [cells.iconUrl],
            [cells.displayName],
            [cells.officialName],
            [cells.businessClient],
            [cells.division],
            [cells.projectManager],
            [cells.status],
            [cells.scheduledDate],
            [cells.wbsItemCodeFormat],
            [cells.mainEmail],
          ],
        },
      ],
    }),
    [intl, cells]
  )
}
